import api from "./api/axiosInstance";
import { isDevelopment } from "../config/env";
import { isAllowedBuyUrl, isHttpUrl } from "./buyUrlPolicy";

const RETAILER_LINK_TYPES = new Set(["affiliate", "purchase", "retailer"]);

/**
 * Fire-and-forget outbound click log before navigating to a retailer.
 */
export async function trackOutboundClick({
  productId,
  destinationUrl,
  source = "unknown",
  linkType = "other",
  sessionId,
  metadata,
}) {
  if (!destinationUrl) return;
  try {
    await api.post("/analytics/outbound-click", {
      productId: productId || undefined,
      destinationUrl,
      source,
      linkType,
      sessionId: sessionId || undefined,
      metadata: metadata || undefined,
    });
  } catch (err) {
    // Never block the user from leaving to buy
    if (isDevelopment) {
      console.warn("outbound click tracking failed", err);
    }
  }
}

export async function openTrackedOutboundUrl({
  url,
  productId,
  source,
  linkType,
  sessionId,
  metadata,
}) {
  if (!url) return;
  const allowed = RETAILER_LINK_TYPES.has(linkType)
    ? isAllowedBuyUrl(url)
    : isHttpUrl(url);
  if (!allowed) return;
  await trackOutboundClick({
    productId,
    destinationUrl: url,
    source,
    linkType,
    sessionId,
    metadata,
  });
  window.open(url, "_blank", "noopener,noreferrer");
}
